import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { FC, ReactElement, useState } from 'react';

import LoadingButton from '../LoadingButton/LoadingButton';

interface DeleteDialogProps {
  onClose: () => void;
  onDelete: () => Promise<void>;
  title: string;
  content: ReactElement;
  alertText?: string;
  open: boolean;
  deleteButtonText?: string;
}

const DeleteDialog: FC<DeleteDialogProps> = ({
  title,
  content,
  onDelete,
  onClose,
  open,
  deleteButtonText = 'Yes, Delete',
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();

    setIsDeleting(true);
    onDelete()
      .then(() => onClose())
      .catch((error: Error) => setError(error.message))
      .finally(() => setIsDeleting(false));
  };

  return (
    <Dialog
      open={open}
      maxWidth='md'
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      fullWidth
      onClose={(e: any, reason) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
      disableEscapeKeyDown={isDeleting}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {error && (
          <Alert sx={{ mb: 2 }} severity='error'>
            {error}
          </Alert>
        )}
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='text'
          color='secondary'
          onClick={onClose}
          disabled={isDeleting}
        >
          Close
        </Button>
        <LoadingButton
          loading={isDeleting}
          color='error'
          onClick={handleDelete}
          disabled={isDeleting}
        >
          {deleteButtonText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteDialog;
